export function OptionWrapper({
  label,
  children,
  className,
  direction = 'horizontal',
}: {
  label: string;
  children: React.ReactNode;
  className?: string;
  direction?: 'horizontal' | 'vertical';
}) {
  return (
    <div
      className={`flex ${direction === 'vertical' ? 'flex-col items-start w-full' : 'flex-row items-center'} gap-2 ${className || ''}`}
    >
      <div className="text-gray-600">{label}</div>
      {children}
    </div>
  );
}
